<template>
  <div class="relative z-1" :key="question._id">
    <TransitionGroup  name="list-simple" tag="div" class="grid grid-cols-1 gap-1 relative" :class="[ question.options.length <= 2 ? 'sm:grid-cols-1' : 'sm:grid-cols-1' ]">
      <QuizOption
        :option="option"
        :question="question"
        :is-result="selected !== null"
        :is-selected="selected === option._id"
        :is-show-faces="isShowFaces"
        :class="[
          selected !== null ? 'pointer-events-none' : ''
        ]"
        @click="() => emit('answer', option._id)"
        :key="option._id"
        v-for="option in options"
      />
    </TransitionGroup>
  </div>
</template>

<script lang="ts" setup>
import { IQuiz, IQuizQuestion } from '@/classes/Quiz'

const props = withDefaults(defineProps<{
  question: IQuizQuestion
  selected?: string | null
  isShowFaces?: boolean
}>(), {
  selected: null,
  isShowFaces: false
})

const emit = defineEmits<{
  (e: 'update', quiz: IQuiz): void,
  (e: 'next'): void
  (e: 'answer', optionId: string): void
}>()

const { question } = toRefs(props)

const options = computed(() => question.value.options.sort((a, b) => props.selected ? b.count - a.count : 1))

</script>